export const decodeHtmlEntities = (encodedString) => {
    const translateRe = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
        nbsp: ' ',
        amp: '&',
        quot: '"',
        lt: '<',
        gt: '>',
    };
    return encodedString
        .replace(translateRe, (_match, entity) => translate[entity])
        .replace(/&#(\d+);/gi, (_match, numStr) => {
        const num = parseInt(numStr, 10);
        return String.fromCharCode(num);
    });
};
//# sourceMappingURL=decodeHtmlEntities.js.map